var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoveToBottomGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 11.576,
    viewBox: "0 0 11 11.576",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7479",
    "data-name": "Group 7479",
    transform: "translate(-939 -240.75)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23589",
    "data-name": "Rectangle 23589",
    width: 11,
    height: 1.6,
    rx: 0.8,
    transform: "translate(950 252.326) rotate(180)",
    fill: "#a6acb5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "right-arrow_1_",
    "data-name": "right-arrow (1)",
    transform: "translate(989.617 241) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7215",
    "data-name": "Group 7215",
    transform: "translate(0 41.346)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4969",
    "data-name": "Path 4969",
    d: "M8.669,44.668,5.487,41.487a.484.484,0,0,0-.682,0l-.289.289a.479.479,0,0,0-.141.341.488.488,0,0,0,.141.345l1.856,1.86H.476A.471.471,0,0,0,0,44.8V45.2a.489.489,0,0,0,.476.5H6.394L4.517,47.57a.478.478,0,0,0,0,.677l.289.288a.484.484,0,0,0,.682,0l3.181-3.181a.486.486,0,0,0,0-.684Z",
    transform: "translate(0 -41.346)",
    fill: "#a6acb5",
    stroke: "#a6acb5",
    strokeWidth: 0.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveToBottomGray);
export default __webpack_public_path__ + "static/media/move-to-bottom-gray.476972a86ac2613ac8b3b708b059e8df.svg";
export { ForwardRef as ReactComponent };